import { type ResourceOwnersSchema } from '@lingoda/api';
import { TermsAndPrivacy } from '@lingoda/legal';
import { Box } from '@lingoda/ui';
import { RegisterFormWrapperStyled } from '../../common';
import { SocialOptions } from './SocialOptions';
import { Login } from './Login';
import Form from './Form';
import type { FormValues } from './Form';

interface Props {
    disabled: boolean;
    handleClick: () => void;
    handleSubmit: (values: FormValues) => Promise<unknown>;
    resourceOwners?: ResourceOwnersSchema[];
}

export const FormContainer = ({ disabled, handleClick, handleSubmit, resourceOwners }: Props) => {
    return (
        <Box sx={{ flex: { xs: 'none', md: '1 1 50%' }, width: { xs: '100%', md: 'auto' } }}>
            <RegisterFormWrapperStyled>
                <Form disabled={disabled} onSubmit={handleSubmit} />
                <Login />
                <SocialOptions
                    disabled={disabled}
                    handleClick={handleClick}
                    resourceOwners={resourceOwners}
                />
                <TermsAndPrivacy typography="caption" sx={{ color: 'text.secondary' }} />
            </RegisterFormWrapperStyled>
        </Box>
    );
};
